/**
 * File: AslSpeakController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslSpeakController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $timeout,CONSTANTS,CQuesConst,Upload,$sce,uploadService) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
    var MQ = MathQuill.getInterface(2);
    let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
    let userId = localStorageService.get("user_id")
    let USER_PATH = userId + "/asl/"
    let schoolId = localStorageService.get("school_id")
    let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
    let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
    let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
    let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
    let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
    let SAVE_URL = CQuesConst.API_CREATE_ASL_SPEAK
        //Object - asl
    $scope.asl = {}

    //String - Url to play audio
    $scope.playableAnswerUrl;
    
    let question = $scope.$parent.$parent.editQuestion
    if(question){
      $scope.question=question.qn_desc;
      $scope.isLatex=question.isLatex;
      $scope.ans_audio_url = question.ans_audio_url;
      if (question.ans_audio_url) {
        let src = PREVIEW_URL + question.ans_audio_url
        $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src)
      }
    }
    $timeout(() => {
      var MQ = MathQuill.getInterface(2);
      var textQuestion = document.getElementById('text-question');
      textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
      if ($scope.qn_desc !== undefined) {
        textQuestion.textContent = $scope.qn_desc
      }
      var mathField = MQ.MathField(textQuestion, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
          edit: function() {
            $scope.qn_desc = mathField.latex()
          }
        }
      });
    }, 10)

    /*
     * Function to upload audio
     *
     * @return : null
     */
    $scope.uploadAudio = (file) => {
      if (fileValidate(file)) {
        let user_id = userId
        Upload.upload({
          url: UPLOAD_URL,
          data: {
            file: file,
            'userPath': USER_PATH
          }
        }).then(function(resp) {
          updateAudioUrl(resp.data)
        })
      }
    }

    /*
     * Function to upload audio
     *
     * @return : null
     */
    function updateAudioUrl(url) {
      $scope.ans_audio_url = url;
      let src = PREVIEW_URL + url
      $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src)
      $scope.isLoading = true
      toastr.success("Audio uploaded successfully...")
    }

    /*
     * Function to validate audio files
     *
     * @file : uploaded file
     *
     * @return : Boolean - validity of file
     */
    function fileValidate(file) {
      let supportedFrmts = ['mp3', 'wav']
      let isValid = false

      if (file && !file.$error && file !== undefined && file !== null) {
        let fileSize = ((file.size) / 1048576)
        let extValue = file.name.split('.').pop();
        if (_.contains(supportedFrmts, extValue)) {
          // if (file.type === "audio/mp3" || file.type === "audio/wav") {
          if (fileSize < 6.00) {
            if (file.name !== "") {
              $scope.isLoading = false;
              isValid = true;
            } else {
              $scope.isLoading = true;
              toastr.error("File is not valid")
              isValid = false
            }
          } else {
            $scope.isLoading = true;
            toastr.error("Please upload audio file size less than 6MB")
            isValid = false
          };
        } else {
          $scope.isLoading = true;
          toastr.error('Please select supported mp3 or wav file formats.')
          isValid = false
        }
      }
      return isValid
    }

    /*
     * Function to save recorded file url
     *
     * @url : uploaded file url
     *
     * @return : null
     */
    $scope.saveRecordedUrl = (url) => {
      updateAudioUrl(url)
    }

    $scope.paste = function(e){
      e.preventDefault();
      return false
    }

    //Adding asl-speaking question from UI
    $scope.$on('addAslSpeaking', function() {
      let details = localStorageService.get("questionDetails")
      let question = details.question
      let activityErrorCount = details.errorCount;
      //Validation 
      $scope.errors = {};

      if ($scope.qn_desc === undefined || $scope.qn_desc === "") {
        $scope.errors['qn_desc'] = "Paragraph is required"
        $scope.activityErrorCount++;
      }else if($scope.qn_desc.length>500){
        $scope.errors['qn_desc']="Paragraph does not exceed 500 characters";
        $scope.activityErrorCount++;
      }
      // if ($scope.ans_audio_url === undefined || $scope.ans_audio_url === "") {
      //   $scope['qn_desc']="Paragraph is required"
      //   $scope.activityErrorCount++;
      // }
      if(activityErrorCount===0)
     {
      $scope.$parent.isSaveClicked = true;
     let obj={ 
                    "_id": $scope._id,
                    "question_theme_id": question.theme._id,
                    "question_theme_name": question.theme.name,
                    "desc": $scope.desc,
                    "descImage": $scope.descImage,
                    "explanation": $scope.explanation,
                    "explanationImage": $scope.explanationImage,
                    "strand": question.strand,
                    "tag": question.tag,
                    "wave": question.wave,
                    "qn_desc": '' + $scope.question,
                    "isLatex": $scope.isLatex,
                    "level": question.level,
                    "subject_id": question.subject_id,
                    "school_id": question.school_id,
                    "questionImg": $scope.questionImage,
                    "session_id": question.session_id,
                    "batch_id": question.batch_id,
                    "class_id": question.class_id,
                    "curriculum_id": question.curriculum_id,
                    "xlink": question.link_theme,
                    "cognitive_skills": question.cognitive_skill,
                    "isNotAddToQp": question.isNotAddToQp,
                    "is_traditional_activity": question.is_traditional_activity,
                    "qp_id": question.qp_id,
                    "activity_id": question.activity_id,
                    "user_id": userId,
                    "created_dt": $scope.created_dt,
                    "content_editor_id": $scope.content_editor_id,
                    "ans_audio_url": $scope.ans_audio_url
     }
     
              //SAVE CALL
              authService.callAPI(SAVE_URL, "POST", obj, function(resObj) {
                let result = resObj.result
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false)
                    $rootScope.setLoader(false)
                    $rootScope.resetValues()
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        })
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession()
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false)
                    $rootScope.setLoader(false)
                    toastr.error("Network Error")
                }
                _.defer(() => {
                    $scope.$apply()
                })
            })
     }
     else {
      $rootScope.setHideSaveButton(false)
      $rootScope.setLoader(false)
      toastr.error("Please fill all mandatory fields")
  }
      
})

        //On destroy function
        this.$onDestroy = () => {
        }

    }
}

export default AslSpeakController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslSpeakController.js